module.exports = __webpack_public_path__ + "img/1F1EE-1F1EA.ea496d49.svg";